import { Box, Container, Text, Link, Alert, AlertIcon, VStack, Heading } from '@chakra-ui/react';
import { ExternalLinkIcon } from '@chakra-ui/icons';

export default function OpenSourceBanner() {
	return (
		<Box bg="green.500" py={8} mb={8}>
			<Container maxW={'6xl'}>
				<VStack spacing={4} textAlign="center">
					<Heading
						size="lg"
						color="white"
						fontWeight="bold"
					>
						🎉 Reminder Bot is Now Open Source! 🎉
					</Heading>
					<Text fontSize="lg" color="white" fontWeight="medium">
						The Reminder Bot app is now fully open source and free to use with no limitations!
					</Text>
					<Link
						href="https://github.com/AddReminders/Reminders-in-RocketChat"
						isExternal
						color="white"
						fontSize="xl"
						fontWeight="bold"
						textDecoration="underline"
						_hover={{ color: 'gray.100' }}
					>
						Visit GitHub Repository <ExternalLinkIcon mx="2px" />
					</Link>
				</VStack>
			</Container>
		</Box>
	);
}

export function WebsiteDeprecationNotice() {
	return (
		<Alert status="warning" variant="solid" mb={6}>
			<AlertIcon />
			<Text fontWeight="medium">
				⚠️ This website will be taken down soon. Please use{' '}
				<Link
					href="https://github.com/AddReminders/Reminders-in-RocketChat"
					isExternal
					textDecoration="underline"
					fontWeight="bold"
				>
					GitHub
				</Link>{' '}
				for all documentation, support, and updates.
			</Text>
		</Alert>
	);
}

